import { convertValuesFM } from "../../../../shared-resources/utils";
import { formatWeekEndDate } from "./weeklyEACCalculations";

const isEmpty = (value) => value === null || value === undefined || value === "";

export const formatCellValue = (value, format) => {
  if (isEmpty(value)) return "";
  switch (format) {
    case "currency":
      return convertValuesFM(value);
    case "percent": {
      const percentValue = Number(value) * 100;
      return percentValue < 0
        ? `(${Math.abs(percentValue).toFixed(2)}%)`
        : `${percentValue.toFixed(2)}%`;
    }
    // Some API fields (e.g. laborEscalation) are already plain percentage numbers (10 means 10%,
    // per the escalation formula's own "/ 100" — not a 0-1 fraction), so don't scale by 100 again.
    case "percentRaw": {
      const rawValue = Number(value);
      return rawValue < 0
        ? `(${Math.abs(rawValue).toFixed(2)}%)`
        : `${rawValue.toFixed(2)}%`;
    }
    case "date":
      return formatWeekEndDate(value);
    case "number":
      return Number(value).toFixed(2);
    default:
      return value;
  }
};
